import React, { useState, useEffect } from "react"
import { Row } from "reactstrap"
import Select from "react-select"
import axios from "axios"
import Loader from "pages/Separate/Loader"
import configure from "configure"
import secureLocalStorage from "react-secure-storage"

// ─── Helper: treat null / undefined / "null" / "undefined" / "" as empty ──────
const isEmpty = val =>
  val === null ||
  val === undefined ||
  String(val).trim() === "" ||
  String(val).trim().toLowerCase() === "null" ||
  String(val).trim().toLowerCase() === "undefined"

// clean display value — never show the string "null" in an input
const clean = val => (isEmpty(val) ? "" : val)

// red border class for plain inputs
const inputCls = val =>
  `form-control ${isEmpty(val) ? "border-danger" : ""}`

// red border style object for react-select (it doesn't support className on the control directly)
const selectStyles = isInvalid => ({
  menuList: styles => ({ ...styles, background: "white",  }),
  menu: base => ({ ...base, zIndex: 50,  }),
  control: base => ({
    ...base,
    borderColor: isInvalid ? "#dc3545" : base.borderColor,
    "&:hover": { borderColor: isInvalid ? "#dc3545" : base["&:hover"]?.borderColor },
  }),
})

const PersonalDetails = ({ id, verticalActiveTab, staffData }) => {
  document.title = "View Staff | Zithas Crm"

  const [roles, setRoles] = useState([])
  const [departments, setDepartments] = useState([])
  const [staffMember, setStaffMember] = useState([])
  const [swift, setSwift] = useState([])
  const [swiftDec, setSwiftDec] = useState({ label: null, value: null })
  const [countries, setCountries] = useState([])
  const [states, setStates] = useState([])
  const [cities, setCites] = useState([])
  const [inputFields, setInputFields] = useState([{}])
  const [inputFields_1, setInputFields1] = useState([{}])
  const [isLoading, setLoading] = useState(false)
  const [image, setImage] = useState("")
  const [role_name, setRoleName] = useState({ label: null, value: null })
  const [department, setDepartment] = useState({ label: null, value: null })
  const [designation, setDesignation] = useState("")
  const [emp_id, setEmpId] = useState("")
  const [punch_id, setPunchId] = useState("")
  const [date_join, setDateJoin] = useState("")
  const [date_resign, setDateResign] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [passwordType, setPasswordType] = useState("password")
  const [name, setName] = useState("")
  const [custType, setCustType] = useState("new")
  const [alias_name, setAliasName] = useState("")
  const [mobile, setMobile] = useState("")
  const [gender, setGender] = useState("")
  const [birth_date, setBirthDate] = useState("")
  const [marital_status, setMaritialStatus] = useState("")
  const [religion, setReligion] = useState("")
  const [linkedin, setlinkedin] = useState("")
  const [address_1, setAddress1] = useState("")
  const [address_2, setAddress2] = useState("")
  const [country, setCountry] = useState({ label: null, value: null })
  const [state, setState] = useState({ label: null, value: null })
  const [city, setCity] = useState({ label: null, value: null })
  const [pincode, setPincode] = useState("")
  const [pf_account, setPfAccount] = useState("")
  const [aadhaar, setAadhar] = useState("")
  const [pan_account, setPanAccount] = useState("")
  const [passport, setPassport] = useState("")

  const getPersonalDetails = async allOptions => {
    setLoading(true)
    const bearerToken = secureLocalStorage.getItem("auth_token")
    try {
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/staff`,
        headers: {
          Authorization: "Bearer " + bearerToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })

      const item = response.data.data?.filter(temp => temp.id == id)[0]
      staffData(item)
      if (item?.id == id) {
        const role = allOptions?.optionRole?.filter(ob => ob.value == item?.roleid)
        setRoleName({ label: role[0]?.label, value: role[0]?.value })

        const depart = allOptions?.optionDepartment.filter(ob => ob.value == item.department)
        setDepartment({ label: depart[0]?.label, value: depart[0]?.value })

        const shift = allOptions?.option?.filter(ob => ob.value == item.shift_id)
        setSwiftDec({ label: shift[0]?.label, value: shift[0]?.value })

        try {
          await axios({
            method: "get",
            url: `${configure.nodeApi}/departments`,
            headers: { Accept: "application/json", "Content-Type": "application/json" },
          }).then(response => {
            const options = response.data.data.country?.map(ct => ({ value: ct.id, label: ct.name }))
            setCountries(options)
            const cntry = options?.filter(ob => ob.value == item.country)
            setCountry({ label: cntry[0]?.label, value: cntry[0]?.value })
          })
        } catch (error) { console.log(error) }

        try {
          const formData = new FormData()
          formData.append("country", item.country)
          await axios({
            method: "post",
            url: `${configure.nodeApi}/all/states`,
            data: formData,
            headers: { Accept: "application/json", "Content-Type": "application/json" },
          }).then(response => {
            const option = response.data.data?.map(st => ({ value: st.id, label: st.name }))
            setStates(option)
            const stat = option?.filter(ob => ob.value == item.state)
            setState({ label: stat[0]?.label, value: stat[0]?.value })
            setLoading(false)
          })
        } catch (err) { console.log(err); setLoading(false) }

        try {
          const formData = new FormData()
          formData.append("state", item.state)
          await axios({
            method: "post",
            url: `${configure.nodeApi}/city`,
            data: formData,
            headers: { Accept: "application/json", "Content-Type": "application/json" },
          }).then(response => {
            const option = response.data.data?.map(item => ({ value: item.id, label: item.name }))
            setCites(option)
            const cty = option?.filter(ob => ob.value == item.city)
            setCity({ label: cty[0]?.label, value: cty[0]?.value })
            setLoading(false)
          })
        } catch (err) { console.log(err); setLoading(false) }

        // ── Set all fields, cleaning out null/"null" strings ──────────────────
        setPincode(clean(item.zip_code))
        setPfAccount(clean(item.pf_account_number))
        setAadhar(clean(item.aadharcard_number))
        setPassport(clean(item.passport_number))
        setPanAccount(clean(item.pancard_number))
        setImage(`${configure.imgUrl}${item.avatar}`)
        setDesignation(clean(item.designation))
        setEmpId(clean(item.employee_code))
        setPunchId(clean(item.punchid))
        setDateJoin(clean(item.date_of_joining))
        setDateResign(clean(item.date_of_resignation))
        setName(clean(item.name))
        setPassword(clean(item.crm_password))
        setEmail(clean(item.email))
        setAliasName(clean(item.alias_name))
        setMobile(clean(item.phone_number))
        setGender(clean(item.gender))
        setBirthDate(clean(item.dob))
        setMaritialStatus(clean(item.marital_status))
        setReligion(clean(item.religion))
        setlinkedin(clean(item.linkedin))
        setAddress1(clean(item.address))
        setAddress2(clean(item.address_line_2))

        const familyDetails = JSON.parse(item.family_details)
        if (familyDetails !== null) setInputFields(familyDetails)

        const bankDetails = JSON.parse(item.bank_details)
        if (bankDetails !== null) setInputFields1(bankDetails)
      }
      setLoading(false)
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const getStaffData = async () => {
    setLoading(true)
    const bearerToken = secureLocalStorage.getItem("auth_token")
    try {
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/staffData`,
        headers: {
          Authorization: "Bearer " + bearerToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      const option = response.data.data.shift?.map(item => ({
        value: item.id,
        label: `${item.shift_name} - (${item.shift_start_time} - ${item.shift_end_time})`,
      }))
      setSwift(option)
      const optionRole = response.data.data.roles?.map(item => ({ value: item.id, label: item.role_name }))
      setRoles(optionRole)
      const optionDepartment = response.data.data.deparment?.map(item => ({ value: item.id, label: item.department_name }))
      setDepartments(optionDepartment)
      const optionStaff = response.data.data.staff?.map(item => ({ value: item.employee_name, label: item.employee_name }))
      setStaffMember(optionStaff)
      setLoading(false)
      return { option, optionRole, optionDepartment, optionStaff }
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  useEffect(() => { fetchNodeData() }, [])
  const fetchNodeData = async () => {
    const allOptions = await getStaffData()
    await getPersonalDetails(allOptions)
  }

  const togglePassword = () =>
    setPasswordType(prev => (prev === "password" ? "text" : "password"))

  return (
    <>
      {isLoading && <Loader />}
      <div className="repeater" id="addstaff">

        {/* ── General Info ───────────────────────────────────────────────── */}
        <div className="mb-3 shadow bg-white p-4">
          <Row>
            <div className="col-md-6">
              <h4 className="text-dark above">Personal Details</h4>
            </div>
          </Row>
          <h5 className="mb-4 text-dark">General Info</h5>
          <Row>
            <div className="col-md-4 mb-3">
              <label>Role Name</label>
              <Select
                placeholder="-"
                className="basic-multi-select"
                classNamePrefix="select"
                options={roles}
                value={role_name}
                isDisabled={true}
                styles={selectStyles(isEmpty(role_name?.value))}
              />
            </div>
            <div className="col-md-4 mb-3">
              <label>Department</label>
              <Select
                placeholder="-"
                className="basic-multi-select"
                classNamePrefix="select"
                options={departments}
                value={department}
                isDisabled={true}
                styles={selectStyles(isEmpty(department?.value))}
              />
            </div>
            <div className="col-md-4 mb-3">
              <label>Designation</label>
              <input
                type="text"
                placeholder="-"
                className={inputCls(designation)}
                value={designation}
                disabled={true}
              />
            </div>
            <div className="col-md-4 mb-3">
              <label>Shift</label>
              <Select
                placeholder="-"
                className="basic-multi-select"
                classNamePrefix="select"
                options={swift}
                value={swiftDec}
                isDisabled={true}
                styles={selectStyles(isEmpty(swiftDec?.value))}
              />
            </div>
            <div className="col-md-2 mb-3">
              <label>Employee Id <span className="text-danger">*</span></label>
              <input
                required
                type="text"
                placeholder="-"
                className={inputCls(emp_id)}
                value={emp_id}
                disabled={true}
              />
            </div>
            <div className="col-md-2 mb-3">
              <label>Punch Id</label>
              <input
                type="text"
                placeholder="-"
                className={inputCls(punch_id)}
                value={punch_id}
                disabled={true}
              />
            </div>
            <div className="col-md-3 mb-3">
              <div className="pe-5">
                <label>Date Of Joining</label>
                <input
                  type="date"
                  className={inputCls(date_join)}
                  value={date_join}
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-md-4 mb-3 mb-md-0">
              <label>Date of Resignation / Date of Termination</label>
              <input
                type="date"
                className={inputCls(date_resign)}
                value={date_resign}
                disabled={true}
              />
            </div>
            <div className="col-md-4 mb-3 mb-md-0">
              <label>Email Id <span className="text-danger">*</span></label>
              <input
                required
                type="text"
                placeholder="-"
                className={inputCls(email)}
                value={email}
                disabled={true}
              />
            </div>
            <div className="col-md-4 mb-3 mb-md-0">
              <label>Password</label>
              <div className="bd-pass">
                <input
                  type={passwordType}
                  placeholder="Enter Password"
                  className={inputCls(password)}
                  value={password}
                  disabled={true}
                />
                <a className="bd-pass-icon" onClick={togglePassword}>
                  {passwordType === "password"
                    ? <i className="fas fa-eye-slash"></i>
                    : <i className="fas fa-eye"></i>}
                </a>
              </div>
            </div>
          </Row>
        </div>

        {/* ── Personal Details ───────────────────────────────────────────── */}
        <div className="shadow bg-white p-4">
          <h5 className="mb-4 text-dark">Personal Details</h5>
          <div className="col-12 mb-3">
            <label className="d-block">Staff Type</label>
            <span className="me-4">
              <input className="form-check-input input-location" type="radio" id="new" defaultChecked disabled name="type" value="new" />
              <label htmlFor="new" className="ms-2">New</label>
            </span>
            <span>
              <input className="form-check-input input-location" type="radio" disabled id="existing" name="type" value="existing" />
              <label htmlFor="existing" className="ms-2">Existing</label>
            </span>
          </div>
          <Row>
            <div className="col-md-3 col-lg-4 mb-3 empl-name-wrapper">
              <label>Employee Name <span className="text-danger">*</span></label>
              {custType === "new" ? (
                <input
                  type="text"
                  placeholder="-"
                  className={`empl-name ${inputCls(name)}`}
                  value={name}
                  disabled={true}
                />
              ) : (
                <Select
                  placeholder="-"
                  className="basic-multi-select"
                  classNamePrefix="border-radius select"
                  styles={selectStyles(isEmpty(name))}
                  options={staffMember}
                  isDisabled={true}
                />
              )}
            </div>
            <div className="col-md-3 mb-3">
              <label>Alias Name <span className="text-danger">*</span></label>
              <input
                required
                type="text"
                placeholder="-"
                className={inputCls(alias_name)}
                value={alias_name}
                disabled={true}
              />
            </div>
            <div className="col-md-3 col-lg-2 mb-3">
              <label>Phone Number <span className="text-danger">*</span></label>
              <input
                required
                type="text"
                placeholder="-"
                className={inputCls(mobile)}
                value={mobile}
                disabled={true}
              />
            </div>
            <div className="col-md-2 mb-3">
              <label>Gender <span className="text-danger">*</span></label>
              <select
                required
                value={gender}
                className={`form-select ${isEmpty(gender) || gender === "None" ? "border-danger" : ""}`}
                disabled={true}
              >
                <option value="None">None</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
            <div className="col-md-3 mb-3">
              <div className="pe-5">
                <label>Birth Date</label>
                <input
                  type="date"
                  className={inputCls(birth_date)}
                  value={birth_date}
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-md-3 mb-3 mb-md-0">
              <label>Marital Status</label>
              <select
                value={marital_status}
                className={`form-select ${isEmpty(marital_status) || marital_status === "Nothing Selected" ? "border-danger" : ""}`}
                disabled={true}
              >
                <option value="Nothing Selected">Nothing Selected</option>
                <option value="Unmarried">Unmarried</option>
                <option value="Married">Married</option>
                <option value="Divorce">Divorce</option>
              </select>
            </div>
            <div className="col-md-3 mb-3 mb-md-0">
              <label>Religion</label>
              <input
                type="text"
                placeholder="-"
                className={inputCls(religion)}
                value={religion}
                disabled={true}
              />
            </div>
            <div className="col-md-3 mb-3 mb-md-0">
              <label>LinkedIn</label>
              <input
                type="text"
                placeholder="-"
                className={inputCls(linkedin)}
                value={linkedin}
                disabled={true}
              />
            </div>
          </Row>
        </div>

        {/* ── Address Details ────────────────────────────────────────────── */}
        <div className="mb-3 shadow bg-white p-4">
          <h5 className="mb-4 text-dark">Address Details</h5>
          <Row>
            <div className="col-md-3 mb-3">
              <label>Address Line 1</label>
              <input type="text" placeholder="-" className={inputCls(address_1)} value={address_1} disabled={true} />
            </div>
            <div className="col-md-3 mb-3">
              <label>Address Line 2</label>
              <input type="text" placeholder="-" className={inputCls(address_2)} value={address_2} disabled={true} />
            </div>
            <div className="col-md-3 mb-3">
              <label>Country</label>
              <Select
                placeholder="-"
                className="basic-multi-select"
                classNamePrefix="select"
                options={countries}
                value={country}
                isDisabled={true}
                styles={selectStyles(isEmpty(country?.value))}
              />
            </div>
            <div className="col-md-3 mb-3">
              <label>State</label>
              <Select
                placeholder="-"
                className="basic-multi-select"
                classNamePrefix="select"
                options={states}
                value={state}
                isDisabled={true}
                styles={selectStyles(isEmpty(state?.value))}
              />
            </div>
            <div className="col-md-3 mb-3 mb-md-0">
              <label>City</label>
              <Select
                placeholder="-"
                className="basic-multi-select"
                classNamePrefix="select"
                options={cities}
                value={city}
                isDisabled={true}
                styles={selectStyles(isEmpty(city?.value))}
              />
            </div>
            <div className="col-md-3 mb-3 mb-md-0">
              <label>Pin Code</label>
              <input type="number" placeholder="-" className={inputCls(pincode)} value={pincode} disabled={true} />
            </div>
          </Row>
        </div>

        {/* ── KYC Details ────────────────────────────────────────────────── */}
        <div className="mb-3 shadow bg-white p-4">
          <h5 className="mb-4 text-dark">KYC Details</h5>
          <Row>
            <div className="col-md-4 mb-4">
              <label>PF Account Number</label>
              <input type="text" placeholder="-" className={inputCls(pf_account)} value={pf_account} disabled={true} />
            </div>
            <div className="col-md-4 mb-4">
              <label>Aadhar Card Number</label>
              <input type="number" placeholder="-" className={inputCls(aadhaar)} value={aadhaar} disabled={true} />
            </div>
            <div className="col-md-4 mb-4">
              <label>PAN Card Number</label>
              <input type="text" placeholder="-" className={inputCls(pan_account)} value={pan_account} disabled={true} />
            </div>
            <div className="col-md-4 mb-4 mb-md-0">
              <label>Passport Number</label>
              <input type="text" placeholder="-" className={inputCls(passport)} value={passport} disabled={true} />
            </div>
          </Row>
        </div>

        {/* ── Family Details ─────────────────────────────────────────────── */}
        <div className="mb-3 shadow bg-white p-4">
          <div className="d-flex justify-content-between mb-4">
            <h5 className="mb-4 text-dark">Family Details</h5>
          </div>
          {inputFields?.map((item, index) => (
            <div className="display-flex align-items-end" key={index}>
              <div className="mb-3 pr-row">
                <label>Member Name</label>
                <input type="text" placeholder="-" className={inputCls(item.member_name)} name="member_name" value={clean(item.member_name)} disabled={true} />
              </div>
              <div className="mb-3 pr-row pl-row">
                <label>Relationship</label>
                <input type="text" placeholder="-" className={inputCls(item.relationship)} name="relationship" value={clean(item.relationship)} disabled={true} />
              </div>
              <div className="mb-3 pr-row pl-row">
                <label>Occupation</label>
                <input type="text" placeholder="-" className={inputCls(item.occupation)} name="occupation" value={clean(item.occupation)} disabled={true} />
              </div>
              <div className="mb-3 pr-row pl-row">
                <label>Contact No</label>
                <input type="number" placeholder="-" className={inputCls(item.contact_no)} name="contact_no" value={clean(item.contact_no)} disabled={true} />
              </div>
            </div>
          ))}
        </div>

        {/* ── Bank Details ───────────────────────────────────────────────── */}
        <div className="mb-3 shadow bg-white p-4">
          <div className="d-flex justify-content-between mb-4">
            <h5 className="mb-4 text-dark">Bank Details</h5>
          </div>
          {inputFields_1?.map((item, index) => (
            <div className="display-flex align-items-end" key={index}>
              <div className="mb-3 pr-row">
                <label>Bank Name</label>
                <input type="text" placeholder="-" className={inputCls(item.bank_name)} name="bank_name" value={clean(item.bank_name)} disabled={true} />
              </div>
              <div className="mb-3 pr-row pl-row">
                <label>Branch Name</label>
                <input type="text" placeholder="-" className={inputCls(item.branch_name)} name="branch_name" value={clean(item.branch_name)} disabled={true} />
              </div>
              <div className="mb-3 pr-row pl-row">
                <label>Bank Account Number</label>
                <input type="number" placeholder="-" className={inputCls(item.account_number)} name="account_number" value={clean(item.account_number)} disabled={true} />
              </div>
              <div className="mb-3 pr-row pl-row">
                <label>IFSC Code</label>
                <input type="text" placeholder="-" className={inputCls(item.ifsc_code)} name="ifsc_code" value={clean(item.ifsc_code)} disabled={true} />
              </div>
            </div>
          ))}
        </div>

      </div>
    </>
  )
}

export default PersonalDetails